import { render, staticRenderFns } from "./RolesSettings.vue?vue&type=template&id=3f63761c&scoped=true"
import script from "./RolesSettings.vue?vue&type=script&lang=js"
export * from "./RolesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f63761c",
  null
  
)

export default component.exports